/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Verdict_Blocked_BodyInputs */

const cs_import_verdict_blocked_body = /** @type {(inputs: Import_Verdict_Blocked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravte chyby níže, nebo povolte commit s chybami (selhané řádky se přeskočí).`)
};

const en_import_verdict_blocked_body = /** @type {(inputs: Import_Verdict_Blocked_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix the errors below, or allow errors if you accept skipping failed rows.`)
};

/**
* | output |
* | --- |
* | "Fix the errors below, or allow errors if you accept skipping failed rows." |
*
* @param {Import_Verdict_Blocked_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_verdict_blocked_body = /** @type {((inputs?: Import_Verdict_Blocked_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Verdict_Blocked_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_verdict_blocked_body(inputs)
	return cs_import_verdict_blocked_body(inputs)
});